import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import AuthenticationService from "../../services/authentication.service";
import classes from './Login.module.scss';
import { StoredFields } from "../../enums/StoredFields";
import { NotificationSeverities } from "../../enums/NotificationSeverities";
import { useState } from "react";
import Notification from "../../views/notification/Notification";

const DEFAULT_ERROR_MESSAGE = 'Something went wrong!'

const Login = () => {
  const [isErrorNotificationOpen, setIsErrorNotificationOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(DEFAULT_ERROR_MESSAGE);
  const [isLogging, setIsLogging] = useState<boolean>(false);
  const location = useLocation();

  const loginHandler = () => {
    secureLocalStorage.setItem(StoredFields.LANDING_ROUTE, location.pathname);
    setIsLogging(true);
    AuthenticationService
      .getUserManager()
      .signinRedirect()
      .catch((error: Error) => {
        setErrorMessage(error.message.length > 0 ? error.message : DEFAULT_ERROR_MESSAGE);
        setIsErrorNotificationOpen(true);
      })
      .finally(() => setIsLogging(false));
  };

  return (
    <>
      <Box className={classes.box}>
        <Box className={`${classes.loginBox}`}>
          <Box className='loginLogo'></Box>
          <Box>
            {isLogging ?
              <Box className='mt-3 d-flex justify-content-center w-100'>
                <CircularProgress className={`${classes['circular-progress']}`} />
              </Box>
              :
              <Button variant='outlined' onClick={loginHandler} className={`${classes.signInButton} w-100 mt-3`}>
                <Typography className={`${classes.buttonText} text-subtitle`}>Continue with onelogin</Typography>
              </Button>
            }
          </Box>
        </Box>
      </Box>
      <Notification
        open={isErrorNotificationOpen}
        onClose={() => setIsErrorNotificationOpen(false)}
        message={errorMessage}
        severity={NotificationSeverities.ERROR}
        position={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  );
};

export default Login;
